module.exports = __webpack_public_path__ + "img/account.6cc3a8d7.svg";